<template>
  <v-dialog v-model="visible" max-width="1200px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ nombreItem }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="6" lg="4" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';
import { formatearFechaCadena } from '../utils/funciones';

export default {
  name: 'ModalMostrarProgramaUniversidad',
  mixins: [programaUniversidadMixin],
  computed: {
    listado() {
      return [
        { nombre: 'Código', valor: this.item.codigo },
        { nombre: 'Nombre Programa', valor: this.item.programaNombre },
        { nombre: 'Área', valor: this.item.areaUniversidad?.nombre },
        { nombre: 'Tipo', valor: this.item.categoriaUniversidad?.nombre },
        {
          nombre: 'Gestión / Versión / Grupo',
          valor: `${this.item.gestion} / ${this.item.version} / ${this.item.grupo || '-'}`,
        },
        { nombre: 'Resol. Aprob. Univ.', valor: this.item.resolucionAprobacionUniversidad },
        { nombre: 'Sede Universidad', valor: this.item.sedeUniversidad?.nombre },
        { nombre: 'Fecha Inicio CEUB', valor: formatearFechaCadena(this.item.fechaInicio) || '-' },
        { nombre: 'Fecha Fin CEUB', valor: formatearFechaCadena(this.item.fechaFin) || '-' },
        { nombre: 'Estado', valor: this.item.estado?.toUpperCase() },
        { nombre: 'Plan de Pago', valor: this.item.planPagoUniversidad?.nombre || 'No asignado' },
      ];
    },
  },
  data() {
    return {
      visible: false,
      item: this.generarObjetoFormRegistrar(),
      nombreItem: 'Programa Universidad',
    };
  },
  methods: {
    abrir(data = null) {
      this.item = this.generarObjetoFormEditar(data);
      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
  },
};
</script>